export const biDetailModel = (id) => ({
    id: id,
    bldtId: null,
    docId: null,
    soId: null,

    // ใช้สำหรับแสดงรายละเอียดการส่งสินค้าเฉยๆนะจ๊ะ
    soNo: null,
    soDocDate: null,
    arName: null,
    remark: null,
    itemTotal: null,
    netTotal: null,
    totalVat: null
});